import { AnyAction, Reducer } from "redux";
import { IAppThunkAction } from ".";
import AppConfigApi from "../api/AppConfigApi";
import { LoadState } from "../models/utility/LoadState";

export interface IAppConfigStoreState {
    analyticsKey: string;
    instrumentationKey: string;
    salesPageUrl: string;
    configState: LoadState;
}

export type KnownAction = ILoadAppConfig | IUpdateAppConfig;

export interface ILoadAppConfig {
    type: "APP_CONFIG_LOAD_STATE";
    configState: LoadState;
}

export interface IUpdateAppConfig {
    type: "APP_CONFIG_UPDATE";
    configState: LoadState;
    analyticsKey: string;
    instrumentationKey: string;
    salesPageUrl: string;
}

export const actionCreators = {
    loadAppConfig: (): IAppThunkAction => async (dispatch) => {
        dispatch({
            type: "APP_CONFIG_LOAD_STATE",
            configState: LoadState.Loading
        });

        const response = await AppConfigApi.GetConfig();
        dispatch({
            configState: LoadState.Loaded,
            analyticsKey: response.analyticsKey,
            instrumentationKey: response.instrumentationKey,
            salesPageUrl: response.salesPageUrl,
            type: "APP_CONFIG_UPDATE"
        });
    }
};

export const reducer: Reducer<IAppConfigStoreState> = (
    state: IAppConfigStoreState | undefined,
    incomingAction: AnyAction
) => {
    const action = incomingAction as KnownAction;
    const prevState = state || defaultState;

    switch (action.type) {
        case "APP_CONFIG_LOAD_STATE": {
            return {
                analyticsKey: prevState.analyticsKey,
                instrumentationKey: prevState.instrumentationKey,
                salesPageUrl: prevState.salesPageUrl,
                configState: action.configState
            };
        }
        case "APP_CONFIG_UPDATE": {
            return {
                analyticsKey: action.analyticsKey,
                instrumentationKey: action.instrumentationKey,
                salesPageUrl: action.salesPageUrl,
                configState: action.configState
            };
        }
        default:
            break;
    }

    return prevState;
};

export const defaultState = {
    analyticsKey: "",
    instrumentationKey: "",
    salesPageUrl: "",
    configState: LoadState.NotLoaded
} as IAppConfigStoreState;
